export var BarreRechercheDefaultProps = {
    name: "barre-recherche",
    placeholder: "Rechercher",
    texteBouton: "Rechercher"
};
